/**
 * Step 1 — Splash + Welcome.
 *
 * Copy per doc 04 §4.2-4.3 (splash welcome): greet orang tua, set
 * expectation (5 worksheet/hari), prime untuk personalisasi 2 menit
 * (nama anak → aktivitas favorit → selesai).
 */

import { useRouter } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { AppIcon } from '@/components/app-icon';
import { OnboardingStepShell } from '@/components/onboarding/OnboardingStepShell';
import { Spacing } from '@/constants/theme';
import { MISC_ICON } from '@/lib/icons';
import { trackAnalyticsEvent } from '@/lib/analytics';

import { ONBOARDING_ROUTES, getStepByPath } from '@/constants/onboarding';

export default function WelcomeScreen() {
  const router = useRouter();
  const step = getStepByPath(ONBOARDING_ROUTES.welcome);

  const onKembali = () => router.back();
  const onLewati = () => {
    trackAnalyticsEvent('Onboarding Step Completed', { step_name: 'welcome', skipped: true });
    router.replace(ONBOARDING_ROUTES.childProfile);
  };
  const onLanjut = () => {
    trackAnalyticsEvent('Onboarding Step Completed', { step_name: 'welcome', skipped: false });
    router.push(ONBOARDING_ROUTES.childProfile);
  };

  return (
    <OnboardingStepShell
      progress={step?.progress ?? 1 / 5}
      stepLabel={step?.stepLabel ?? '1 / 5'}
      onKembali={onKembali}
      onLewati={onLewati}
      onLanjut={onLanjut}
    >
      <View style={styles.center}>
        <AppIcon source={MISC_ICON.sparkle} size={88} />
        <ThemedText type="subtitle" style={styles.title}>
          Selamat Datang!
        </ThemedText>
        <ThemedText type="default" themeColor="textSecondary" style={styles.body}>
          Funpaper menyiapkan ide aktivitas pilihan setiap hari untuk si
          kecil. Yuk personalisasi dulu — isi nama anak, pilih aktivitas
          favoritnya, selesai. Cuma 2 menit, kok.
        </ThemedText>
      </View>
    </OnboardingStepShell>
  );
}

const styles = StyleSheet.create({
  center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: Spacing.three,
  },
  title: {
    textAlign: 'center',
  },
  body: {
    textAlign: 'center',
    maxWidth: 320,
  },
});
